module.exports = __webpack_public_path__ + "img/v3.0f2b668a.png";